import React, { PropsWithChildren } from 'react'

import { Box, BoxProps, Icon, IconProperty, Typo, TypoProps } from '../atoms'

export interface SSOBadgeProps extends PropsWithChildren, BoxProps {
  iconSize?: IconProperty
  typoSize?: TypoProps['typoSize']
}

export const SSOBadge = ({
  children,
  iconSize = 'tiny',
  typoSize = 'xs',
  ...props
}: SSOBadgeProps) => (
  <Box
    width='max-content'
    borderRadius={1}
    backgroundColor='body'
    p={2}
    display='flex'
    flexDirection='row'
    alignItems='center'
    gap={2}
    {...props}
  >
    <Icon color='chalk' icon='brand' size={iconSize} />
    <Typo color='chalk' fontWeight={600} lineHeight={1} typoSize={typoSize}>
      {children}
    </Typo>
  </Box>
)
